import styled from "@emotion/styled";
import { SetResumeFixTypeAction } from "../../redux/actions/InterviewActions";
import { useAppDispatch, useAppSelector } from "../../redux/hooks";
import SuggestionRow from "../../shared/components/SuggestionRow";
import ResumeFixType, { textForResumeType } from "../../shared/enums/ResumeType";

const StyledRow = styled('div')(() => ({
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'flex-start',
    justifyContent: 'flex-start',
    maxWidth: '100%',
    gap: '15px',
}));

const ResumeTypeSelection = () => {
    const savedJobs = useAppSelector(store => store.savedJobsState.jobsArray);
    const dispatch = useAppDispatch();

    const onTypeOfResumeSelected = (resumeType: ResumeFixType) => {
        dispatch(SetResumeFixTypeAction(resumeType));
    }

    return (
        <StyledRow>
            {Object.values(ResumeFixType).map((type, index) => {
                if (type === ResumeFixType.savedJobs && savedJobs.length === 0) return undefined;
                return <SuggestionRow key={index} title={textForResumeType(type)} onClick={() => onTypeOfResumeSelected(type)} />
            })}
        </StyledRow>
    )
}

export default ResumeTypeSelection